import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { GamePage } from './pages/GamePage';
import { LandingPage } from './pages/LandingPage';
import { AdminPage } from './pages/AdminPage';
import { AdminLoginPage } from './pages/AdminLoginPage';

export default function App() {
  return <BrowserRouter><Routes><Route path="/" element={<LandingPage />} /><Route path="/game/:slug" element={<GamePage />} /><Route path="/admin/login/:slug" element={<AdminLoginPage />} /><Route path="/admin/:slug" element={<AdminPage />} /><Route path="*" element={<Navigate to="/" replace />} /></Routes></BrowserRouter>;
}
